/* 1.1 22/09/2026
Gestione allegati NEWS con personalizzazione "allegati_news":
- inserimento e modifica allegati JPG/JPEG/PNG/PDF
- ridimensionamento immagini a massimo 1600x1600
- visualizzazione diretta di immagini e prima pagina dei PDF
- paginazione delle news fino alla prima news con allegato compresa
- navigazione Avanti/Indietro tra le pagine
*/

import React, { useState, useEffect, useRef } from 'react';
import SelezionaData from './SelezionaData';
import { convertiDataComputer2Umano } from './funzioni.js'
import { haPersonalizzazione } from '../funzioni.js';
import Clessidra from '../Pagine/Clessidra'
import stile from './stile.module.css';
import Resizer from "react-image-file-resizer";
import NewsAllegato from './NewsAllegato.js';

function News(props) {
    const PAGINE = {
        "caricamentoDati": 1,
        "elenco": 2,
        "modifica": 3,
        "inserisci": 4,
    };
    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);
    const [elencoNews, setElencoNews] = useState([]);
    const [idNews, setIdNews] = useState(-1);
    const [titolo, setTitolo] = useState("");
    const [testo, setTesto] = useState("");
    const [dataEliminazione, setDataEliminazione] = useState("");
    const [elementoSelezionato, setElementoSelezionato] = useState(-1);

    const [contenutoFileAllegato, setContenutoFileAllegato] = useState("");
    const [typeFileAllegato, setTypeFileAllegato] = useState("");
    const [estensioneFileAllegato, setEstensioneFileAllegato] = useState("");
    const [flagAllegatoModificato, setFlagAllegatoModificato] = useState(false);
    const [flagEliminaAllegato, setFlagEliminaAllegato] = useState(false);
    const [semaforoElaborazioneAllegato, setSemaforoElaborazioneAllegato] = useState(false);

    const [pagineNews, setPagineNews] = useState([]);
    const [indicePaginaNews, setIndicePaginaNews] = useState(0);
    const [haAvanti, setHaAvanti] = useState(false);
    const [numeroNews, setNumeroNews] = useState(0);

    const inputAllegatoRef = useRef(null);

    function dataEliminazionePredefinita() {

        const data = new Date();
        data.setDate(data.getDate() + 30);

        const anno = data.getFullYear();
        const mese = String(data.getMonth() + 1).padStart(2, "0");
        const giorno = String(data.getDate()).padStart(2, "0");

        return anno + "-" + mese + "-" + giorno;
    }

    function scaricaElencoNews(ultimoTimestamp=0, ultimoId=0, nuovaPagina=false) {

        const datiRichiesta = {
            op: "elencoNews",
            emak: props.emak,
            sessionId: props.sessionId
        };

        if (haPersonalizzazione(props.identitaSelezionata, "allegati_news")) {
            datiRichiesta.ultimoTimestamp = ultimoTimestamp;
            datiRichiesta.ultimoId = ultimoId;
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(datiRichiesta)
        };

        setPagina(PAGINE.caricamentoDati);

        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {

                    if (valore_di_ritorno.verifvers === 0) {
                        props.callbackAggiornaApp();
                        return;
                    }

                    if (valore_di_ritorno.risultatoOperazione === 2) {
                        props.callback(props.PAGINECLIENTI.login);
                        return;
                    }

                    if (valore_di_ritorno.risultatoOperazione !== 1) {
                        window.alert("Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica");
                        props.callback(props.PAGINECLIENTI.login);
                        return;
                    }

                    const nuovaElencoNews = valore_di_ritorno.risultatoRitorno;

                    setElencoNews(nuovaElencoNews);

                    if (!nuovaPagina) {
                        setNumeroNews(valore_di_ritorno.numeroNews);
                    }

                    if (haPersonalizzazione(props.identitaSelezionata, "allegati_news")) {

                        setHaAvanti(valore_di_ritorno.haAvanti === 1);

                        if (nuovaPagina) {

                            setPagineNews((paginePrecedenti) => {

                                const nuovePagine = [...paginePrecedenti];

                                nuovePagine.push({
                                    elencoNews: nuovaElencoNews,
                                    haAvanti: valore_di_ritorno.haAvanti === 1,
                                    ultimoTimestamp: valore_di_ritorno.ultimoTimestamp,
                                    ultimoId: valore_di_ritorno.ultimoId
                                });

                                return nuovePagine;
                            });

                            setIndicePaginaNews((indice) => indice + 1);

                        } else {

                            setPagineNews([{
                                elencoNews: nuovaElencoNews,
                                haAvanti: valore_di_ritorno.haAvanti === 1,
                                ultimoTimestamp: valore_di_ritorno.ultimoTimestamp,
                                ultimoId: valore_di_ritorno.ultimoId
                            }]);

                            setIndicePaginaNews(0);
                        }
                    }

                    setElementoSelezionato(-1);
                    setPagina(PAGINE.elenco);
                },

                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );
    }

    function insModNews() {

        if (titolo === "") {
            window.alert("Indica il titolo della news");
            return;
        }

        if (haPersonalizzazione(props.identitaSelezionata, "allegati_news")) {

            if (
                testo.trim() === "" &&
                contenutoFileAllegato === ""
            ) {
                window.alert("Indica il testo della news oppure inserisci un allegato");
                return;
            }

        } else {

            if (testo === "") {
                window.alert("Indica il testo della news");
                return;
            }
        }

        if (dataEliminazione === "") {
            window.alert("Indica la data di eliminazione della news");
            return;
        }

        setPagina(PAGINE.caricamentoDati);

        let requestOptions;

        if (haPersonalizzazione(props.identitaSelezionata, "allegati_news")) {

            const formData = new FormData();

            formData.append(
                'op',
                pagina === PAGINE.modifica ? "newsMod" : "newsIns"
            );

            formData.append(
                'idElemento',
                pagina === PAGINE.modifica ? idNews : 0
            );

            formData.append('titolo', titolo);
            formData.append('testo', testo);
            formData.append('dataEliminazione', dataEliminazione);
            formData.append('emak', props.emak);
            formData.append('sessionId', props.sessionId);

            if (flagAllegatoModificato) {

                formData.append(
                    'contenutoFileFoto',
                    contenutoFileAllegato
                );

                formData.append(
                    'estensioneFileFoto',
                    estensioneFileAllegato
                );

                formData.append(
                    'typeFileFoto',
                    typeFileAllegato
                );
            }

            formData.append(
                'flagEliminaFoto',
                flagEliminaAllegato ? "on" : ""
            );

            requestOptions = {
                method: 'POST',
                body: formData
            };

        } else {

            requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    op: pagina === PAGINE.modifica ? "newsMod" : "newsIns",
                    idElemento: pagina === PAGINE.modifica ? idNews : 0,
                    titolo: titolo,
                    testo: testo,
                    dataEliminazione: dataEliminazione,
                    emak: props.emak,
                    sessionId: props.sessionId
                })
            };
        }

        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {

                    if (valore_di_ritorno.verifvers === 0) {
                        props.callbackAggiornaApp();
                        return;
                    }

                    if (valore_di_ritorno.risultatoOperazione === 2) {
                        props.callback(props.PAGINECLIENTI.login);
                        return;
                    }

                    if (valore_di_ritorno.risultatoOperazione !== 1) {

                        if (
                            valore_di_ritorno.mess !== undefined &&
                            valore_di_ritorno.mess !== ""
                        ) {
                            window.alert(valore_di_ritorno.mess);
                        } else {
                            window.alert(
                                "Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"
                            );
                        }

                        setPagina(
                            pagina === PAGINE.modifica
                                ? PAGINE.modifica
                                : PAGINE.inserisci
                        );

                        return;
                    }

                    /*
                    * Non modifico localmente elencoNews.
                    *
                    * L'aggiunta/modifica dell'allegato può cambiare il punto
                    * in cui termina la prima pagina.
                    * Ricarico quindi l'elenco dal server.
                    */
                    setPagineNews([]);
                    setIndicePaginaNews(0);
                    setElementoSelezionato(-1);

                    scaricaElencoNews();
                },

                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );
    }

    function cancNews(id, indiceInElencoNews) {
        //console.log("Richiesta cancellazione news id="+id+" e posizione in array="+indiceInElencoNews);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                op: "newsCanc", 
                idElemento: id,
                emak: props.emak, 
                sessionId: props.sessionId
            })
        };
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.verifvers === 0) {
                        // necessario aggiornare la app
                        props.callbackAggiornaApp();
                        return;
                    }
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) {
                        if (valore_di_ritorno.mess !== "") {
                            window.alert(valore_di_ritorno.mess); 
                        } else {
                            window.alert("Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                        }
                        props.callback(props.PAGINECLIENTI.login);
                        return; 
                    }
                    setPagineNews([]);
                    setIndicePaginaNews(0);
                    setElementoSelezionato(-1);
                    scaricaElencoNews();                    
                },
                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );
    }

    function paginaNewsAvanti() {

        const prossimoIndice = indicePaginaNews + 1;

        /*
        * La pagina è già stata caricata in precedenza.
        */
        if (prossimoIndice < pagineNews.length) {

            const paginaSuccessiva = pagineNews[prossimoIndice];

            setIndicePaginaNews(prossimoIndice);
            setElencoNews(paginaSuccessiva.elencoNews);
            setHaAvanti(paginaSuccessiva.haAvanti);
            setElementoSelezionato(-1);

            return;
        }

        /*
        * La pagina non è ancora stata caricata.
        * Uso il cursore dell'attuale pagina.
        */
        const paginaAttuale = pagineNews[indicePaginaNews];

        if (!paginaAttuale || !paginaAttuale.haAvanti) return;

        scaricaElencoNews(
            paginaAttuale.ultimoTimestamp,
            paginaAttuale.ultimoId,
            true
        );
    }


    function paginaNewsIndietro() {

        if (indicePaginaNews <= 0) return;

        const nuovoIndice = indicePaginaNews - 1;
        const paginaPrecedente = pagineNews[nuovoIndice];

        setIndicePaginaNews(nuovoIndice);
        setElencoNews(paginaPrecedente.elencoNews);
        setHaAvanti(paginaPrecedente.haAvanti);
        setElementoSelezionato(-1);
    }    

    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {            
            props.setFlagRichiestaBack(false);
            switch (pagina) {
                case PAGINE.elenco:

                    if (
                        haPersonalizzazione(props.identitaSelezionata, "allegati_news") &&
                        indicePaginaNews > 0
                    ) {
                        paginaNewsIndietro();
                    } else {
                        props.callback(props.PAGINECLIENTI.home);
                    }

                    break;

                case PAGINE.modifica: setPagina(PAGINE.elenco); break;
                case PAGINE.inserisci: setPagina(PAGINE.elenco); break;
                default: props.callback(props.PAGINECLIENTI.home); break;
            }
        } 
    }, [props.flagRichiestaBack])  

    function aggiornaFileAllegato(event) {

        const valore = event.target.files[0];

        if (!valore) return;

        const estensioneOriginale = valore.name.split('.').pop().toLowerCase();

        if (
            estensioneOriginale !== "jpg" &&
            estensioneOriginale !== "jpeg" &&
            estensioneOriginale !== "png" &&
            estensioneOriginale !== "pdf"
        ) {
            window.alert("Sono ammessi solamente file JPG, JPEG, PNG o PDF");
            return;
        }

        if (valore.type === "application/pdf") {

            if (valore.size > 5000000) {
                window.alert("Seleziona un PDF che non sia più grande di 5 MB");
                return;
            }

            setContenutoFileAllegato(valore);
            setTypeFileAllegato("application/pdf");
            setEstensioneFileAllegato("pdf");
            setFlagAllegatoModificato(true);
            setFlagEliminaAllegato(false);

            return;
        }

        if (!valore.type.startsWith("image")) {
            window.alert("Sono ammessi solamente file JPG, JPEG, PNG o PDF");
            return;
        }

        if (semaforoElaborazioneAllegato) return;

        setSemaforoElaborazioneAllegato(true);

        let nuovoTipo = valore.type.substring(6);
        let typeFile = valore.type;
        let estensione = estensioneOriginale;

        if (
            nuovoTipo.toUpperCase() !== "JPG" &&
            nuovoTipo.toUpperCase() !== "JPEG" &&
            nuovoTipo.toUpperCase() !== "PNG"
        ) {
            nuovoTipo = "JPEG";
            typeFile = "image/jpeg";
            estensione = "jpg";
        }

        try {

            Resizer.imageFileResizer(
                valore,
                1600,
                1600,
                nuovoTipo,
                90,
                0,
                (uri) => {

                    setContenutoFileAllegato(uri);
                    setTypeFileAllegato(typeFile);
                    setEstensioneFileAllegato(estensione);
                    setFlagAllegatoModificato(true);
                    setFlagEliminaAllegato(false);
                    setSemaforoElaborazioneAllegato(false);
                },
                "base64"
            );

        } catch (err) {

            setSemaforoElaborazioneAllegato(false);

            window.alert(
                "Si è verificato un errore nel ridimensionamento dell'immagine"
            );
        }
    }


    function eliminaAllegato() {

        setContenutoFileAllegato("");
        setTypeFileAllegato("");
        setEstensioneFileAllegato("");
        setFlagAllegatoModificato(false);
        setFlagEliminaAllegato(true);
    }    

    useEffect(() => {
        scaricaElencoNews()
    },[]);

    if (pagina === PAGINE.caricamentoDati) {
        return (<Clessidra loading={true} />)
    }

    if (pagina === PAGINE.inserisci || pagina === PAGINE.modifica) {
        return (
            <div className={stile.contenitorePrincipale} style={{ overflowY: 'auto', padding:10 }}>
    
                <div>
    
                    <div className={stile.eventiModificaTestoTitoli} style={{paddingBottom:5}}>
                        {pagina === PAGINE.modifica ? "Modifica news" : "Inserisci nuova news"}
                    </div>
    
                    <div className={stile.eventiModificaTestoTitoli}>Titolo*</div>
                    <div style={{display: 'flex', flexDirection:'row'}}>
                        <input value={titolo} onChange={(v) => setTitolo(v.target.value)} maxLength={200} style={{flex:1}} className={stile.eventiModificaInputTesto}></input>
                        <div onClick={() => setTitolo("")}>
                            <img
                                style={{marginLeft:5}} className={stile.iconaPiccolaQuadrata}
                                src={require('./x.png')}
                            />
                        </div>
                    </div>                            
    
                    <div className={stile.eventiModificaTestoTitoli}>
                        {haPersonalizzazione(props.identitaSelezionata, "allegati_news")
                            ? "Testo"
                            : "Testo*"}
                    </div>
                    <div style={{display: 'flex', flexDirection:'row'}}>
                        <textarea value={testo} onChange={(v) => setTesto(v.target.value)} rows={10} maxLength={10000} style={{flex:1, textAlignVertical:'top'}} className={stile.eventiModificaInputTesto}></textarea>
                        <div onClick={() => setTesto("")}>
                            <img
                                style={{marginLeft:5}} className={stile.iconaPiccolaQuadrata}
                                src={require('./x.png')}
                            />
                        </div>
                    </div>

                    {haPersonalizzazione(props.identitaSelezionata, "allegati_news") &&
                        <div style={{marginTop:15}}>

                            <div className={stile.eventiModificaTestoTitoli}>
                                Allegato JPG, PNG o PDF
                            </div>

                            {semaforoElaborazioneAllegato ?
                                <Clessidra loading={true}/>
                            :
                                <>
                                    {contenutoFileAllegato !== "" &&
                                        <NewsAllegato
                                            contenutoFile={contenutoFileAllegato}
                                            tipoFile={typeFileAllegato}
                                        />
                                    }

                                    <input
                                        ref={inputAllegatoRef}
                                        type="file"
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        onChange={aggiornaFileAllegato}
                                        style={{display:"none"}}
                                    />

                                    <div
                                        className={[stile.baVerdeSoft, stile.baNormale].join(" ")}
                                        style={{marginTop:8}}
                                        onClick={() => inputAllegatoRef.current.click()}
                                    >
                                        {contenutoFileAllegato !== "" ? "Cambia allegato" : "Aggiungi allegato"}
                                    </div>

                                    {contenutoFileAllegato !== "" &&
                                        <div
                                            className={[stile.baRossoSoft, stile.baNormale].join(" ")}
                                            style={{marginTop:8}}
                                            onClick={() => eliminaAllegato()}
                                        >
                                            Elimina allegato
                                        </div>
                                    }
                                </>
                            }

                        </div>
                    }                    
    
                    <div className={stile.eventiModificaTestoTitoli}>Data di eliminazione automatica*:</div>
                    <SelezionaData data={dataEliminazione} setData={setDataEliminazione} titolo="Data di eliminazione"/>
                </div>
    
                <div style={{ display:'flex', marginTop: 10, marginBottom:10, marginLeft:10, marginRight:10, flexDirection: 'row' }}>

                    <div 
                        className={[stile.baRossoSoft, stile.baNormale].join(" ")}
                        onClick={() => { setPagina(PAGINE.elenco)  }}
                    >
                        <div className={stile.spazioIconaPiccola}>
                            <img
                                className={stile.iconaPiccolaQuadrata}
                                src={require('./annullabianco.png')}
                            />
                        </div>
                        Annulla
                    </div>
                    
                    <div 
                        className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex, stile.baSecondoBottone].join(" ")}
                        onClick={() => { insModNews(); }}
                    >
                        <div className={stile.spazioIconaPiccola}>
                            <img
                                className={stile.iconaPiccolaQuadrata}
                                src={require('./modificabianco.png')}
                            />
                        </div>
                        Memorizza
                    </div>                        
                </div>                
    
            </div>
    
        )
    }    
    
    if (pagina === PAGINE.elenco) {

        let primaNewsPagina = 1;

        for (let i=0; i<indicePaginaNews; i++) {
            primaNewsPagina += pagineNews[i].elencoNews.length;
        }

        const ultimaNewsPagina =
            primaNewsPagina + elencoNews.length - 1;

        return (        
            <div className={stile.contenitorePrincipale} style={{ overflowY: 'scroll' }}>
                <div style={{display:"flex", flexDirection: "row", paddingLeft:10, paddingRight:10, paddingBottom:10, paddingTop:5, marginBottom:5, backgroundColor:"#E0E0E0"}}>
                    <div 
                        className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex].join(" ")}  
                        onClick={() => { 
                            setTitolo("");
                            setTesto("");
                            setDataEliminazione(dataEliminazionePredefinita());
                            setContenutoFileAllegato("");
                            setTypeFileAllegato("");
                            setEstensioneFileAllegato("");
                            setFlagAllegatoModificato(false);
                            setFlagEliminaAllegato(false);
                            setPagina(PAGINE.inserisci);
                        }}
                    >
                        Inserisci nuova
                    </div>
                </div>
    
                {numeroNews > 0 &&
                    <div style={{
                        textAlign:"center",
                        padding:8,
                        fontSize:14
                    }}>
                        News {primaNewsPagina === ultimaNewsPagina
                            ? primaNewsPagina
                            : primaNewsPagina + "-" + ultimaNewsPagina
                        } di {numeroNews}
                    </div>
                }

                {elencoNews.map((x, i) =>
                    <div
                        key={i}
                        className={
                            x.NUOVA === 1
                                ? stile.elencoSchedeContenitoreElementoEvidenziato
                                : elementoSelezionato === i
                                    ? stile.elencoSchedeContenitoreElementoSelezionato
                                    : stile.elencoSchedeContenitoreElemento
                        }
                        style={{
                            flexWrap:"wrap"
                        }}
                    >
                        <div                             
                            style={{flex:1}}
                            onClick={() => { 
                                setElementoSelezionato(i);
                            }}
                        >
                            <div className={stile.elencoSchedeNome}>
                                {x.TITOLO}
                            </div>
                            <div className={stile.elencoSchedeTesto}>
                                {x.TESTO.length < 100 || elementoSelezionato === i ? x.TESTO : x.TESTO.substr(0, 100) + "...[continua]"}
                            </div>                        
                        </div>
    
                        { (props.identitaSelezionata.flag_staff && x.FLAG_AMMINISTRAZIONE !== 1) || (props.identitaSelezionata.flag_amministrazione) ?
                        <div 
                            style={{width:50, alignItems:"center"}}
                            onClick={() => {
                                setElementoSelezionato(i);
                                setIdNews(x.ID);
                                setTitolo(x.TITOLO);
                                setTesto(x.TESTO);
                                setDataEliminazione(x.DATA_ELIMINAZIONE);
                                if (haPersonalizzazione(props.identitaSelezionata, "allegati_news")) {

                                    setContenutoFileAllegato(x.FILE || "");
                                    setTypeFileAllegato(x.TYPE || "");
                                    setEstensioneFileAllegato(x.ESTENSIONE_FILE || "");

                                    setFlagAllegatoModificato(false);
                                    setFlagEliminaAllegato(false);
                                }                                
                                setPagina(PAGINE.modifica);
                            }}
                        >
                            <img
                                className={stile.iconaPiccolaQuadrata}
                                src={require('./modifica.png')}
                            />
                        </div>
                        : 
                        <div 
                            style={{width:50, alignItems:"center"}}
                            onClick={() => {
                                window.alert("Impossibile modificare la news " + x.TITOLO + ": può essere modificata solo da chi l'ha inserita o da un amministratore");
                            }}
                        >
                            <img
                                className={stile.iconaPiccolaQuadrata}
                                src={require('./modifica-rossa.png')}
                            />
                        </div>
                        }
    
                        { (props.identitaSelezionata.flag_staff && x.FLAG_AMMINISTRAZIONE !== 1) || (props.identitaSelezionata.flag_amministrazione) ?
                        <div 
                            style={{width:50, alignItems:"center"}}
                            onClick={() => { 
                                if (window.confirm("Confermi eliminazione della news? " + x.TITOLO)) cancNews(x.ID,i)
                            }}
                        >
                            <img
                                className={stile.iconaPiccolaQuadrata}
                                src={require('./xgrigia-nobordo.png')}
                            />
                        </div>
                        : 
                        <div 
                            style={{width:50, alignItems:"center"}}
                            onClick={() => { 
                                window.alert("Impossibile eliminare la news " + x.TITOLO + ": può essere modificata solo da chi l'ha inserita o da un amministratore");
                            }}
                        >
                            <img
                                className={stile.iconaPiccolaQuadrata}
                                src={require('./xrossa-nobordo.png')}
                            />
                        </div>
                        }

                        {haPersonalizzazione(props.identitaSelezionata, "allegati_news") &&
                            x.FILE &&
                            <div
                                style={{
                                    flexBasis:"100%",
                                    width:"100%"
                                }}
                            >
                                <NewsAllegato
                                    contenutoFile={x.FILE}
                                    tipoFile={x.TYPE}
                                />
                            </div>
                        }

                        <div className={stile.newsDataAggiornamento}>
                            {convertiDataComputer2Umano(x.DATA_INS_MOD, "")}
                        </div>


                    </div>
                )}

                {haPersonalizzazione(props.identitaSelezionata, "allegati_news") &&
                    (indicePaginaNews > 0 || haAvanti) &&

                    <div
                        style={{
                            display:"flex",
                            flexDirection:"row",
                            padding:10
                        }}
                    >

                        {indicePaginaNews > 0 &&
                            <div
                                className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex].join(" ")}
                                onClick={() => paginaNewsIndietro()}
                            >
                                Indietro
                            </div>
                        }

                        {indicePaginaNews > 0 && haAvanti &&
                            <div style={{width:10}}></div>
                        }

                        {haAvanti &&
                            <div
                                className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex].join(" ")}
                                onClick={() => paginaNewsAvanti()}
                            >
                                Avanti
                            </div>
                        }

                    </div>
                }

            </div>
        )
    }
    
    return (
        <div>Errore pagina non trovata (News)</div>
    )

}

export default News;
